/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { Link, useLocation, useNavigate } from "react-router-dom";

// Material Dashboard 2 React components
import Icon from "@mui/material/Icon";
import customAlert from "components/MDAlert/customAlert";
import MDBox from "components/MDBox";
import MDSwitch from "components/MDSwitch";
import MDTypography from "components/MDTypography";
import { PreserveTable, useCache } from "context";
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import ClientService from "services/client-service";
import authPermission from "utility/auth-permissions";
import { getOptionLabel } from "utility/helpers";

const categoryOptions = [
    {
      key: "insurance_housing",
      value: "Insurance Housing",
      disabled: false,
    },
    {
      key: "restaurants",
      value: "Restaurants",
      disabled: false,
    },
    {
      key: "professional_services",
      value: "Professional Services",
      disabled: false
    }
];
export default function data(props) {
  const { hasPermission } = authPermission();
  const pagePermission = hasPermission("/manage-clients");
  const preserveTable = useContext(PreserveTable);
  const { page_no, page_size, sort_column, sort_column_value, search_value } =
    preserveTable?.client;
  const { openAlertSB, closeAlertSB, renderAlertSB } = customAlert();
  const [clientsData, setClientsData] = useState([]);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = React.useState("");
  const [totalData, setTotalData] = useState(0);
  const { cacheItems, setCacheItems } = useCache();
  const [isData, setIsData] = useState(false);
  const location = useLocation();

  const handleClickOpen = (id) => {
    setSelectedId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (location?.state?.color) {
      openAlertSB(location?.state);
      setTimeout(function () {
        closeAlertSB();
      }, 3000);
    }
    // const getClientsData = async (e) => {
    //   const response = await ClientService.getClients(page_no, page_size, sort_column, sort_column_value, search_value);
    //   setClientsData(response?.data);
    //   setTotalData(response?.total);
    // };
    // getClientsData();
  }, []);

  const getData = async (page_no, page_size, sortColumn, sortColumnValue, searchWord) => {
    const preserveData = {
      page_no,
      page_size,
      sort_column: sortColumn,
      sort_column_value: sortColumnValue,
      search_value: searchWord,
    };
    preserveTable.setPreserveClient(preserveData);
    const response = await ClientService.getClients(
      page_no,
      page_size,
      sortColumn,
      sortColumnValue,
      searchWord
    );
    setClientsData(response?.data);
    setTotalData(response?.total);
    setIsData(true);
  };

  const updateClient = async (id, status) => {
    try {
      const data = { active: status };
      const res = await ClientService.updateActiveClient(id, data);
      if (res) {
        if (cacheItems.hasOwnProperty("clients")) {
          // Create a new object without the key
          const { clients, ...rest } = cacheItems; // Destructure to exclude key
          setCacheItems(rest); // Set the new cache items without key
        }
        openAlertSB({ color: "success", icon: "check", msg: res, title: "Client" });
        setTimeout(function () {
          closeAlertSB();
        }, 3000);
        const response = await ClientService.getClients(
          page_no,
          page_size,
          sort_column,
          sort_column_value,
          search_value
        );
        setClientsData(response?.data);
        setTotalData(response?.total);
      }
    } catch (res) {
      if (res.hasOwnProperty("message")) {
        openAlertSB({ color: "error", icon: "warning", msg: res.message, title: "Client" });
        setTimeout(function () {
          closeAlertSB();
        }, 4000);
      } else {
        openAlertSB({
          color: "error",
          icon: "warning",
          msg: res.errors[0].detail,
          title: "Client",
        });
        setTimeout(function () {
          closeAlertSB();
        }, 4000);
      }
    }
  };

  const deleteClient = async (id) => {
    try {
      const response = await ClientService.deleteClient(id);
      if (response) {
        if (cacheItems.hasOwnProperty("clients")) {
          // Create a new object without the key
          const { clients, ...rest } = cacheItems; // Destructure to exclude key
          setCacheItems(rest); // Set the new cache items without key
        }
        openAlertSB({ color: "success", icon: "check", msg: response, title: "Client" });
        setTimeout(function () {
          closeAlertSB();
        }, 4000);
      }
    } catch (res) {
      if (res.hasOwnProperty("message")) {
        openAlertSB({ color: "error", icon: "warning", msg: res.message, title: "Client" });
        setTimeout(function () {
          closeAlertSB();
        }, 4000);
      } else {
        openAlertSB({
          color: "error",
          icon: "warning",
          msg: res.errors[0].detail,
          title: "Client",
        });
        setTimeout(function () {
          closeAlertSB();
        }, 4000);
      }
    }
    const res = await ClientService.getClients(
      page_no,
      page_size,
      sort_column,
      sort_column_value,
      search_value
    );
    setClientsData(res?.data);
    setTotalData(res?.total);
    setSelectedId("");
    handleClose();
  };

  const allRows = [];
  clientsData?.map((eachClient, index) => {
    const eachData = {
      id: (
        <MDTypography
          component={Link}
          to={pagePermission.edit ? `/manage-clients/edit?id=${eachClient.id}` : ""}
          variant="body2"
          color="text"
        >
          {eachClient.id}
        </MDTypography>
      ),
      name: (
        <MDTypography display="block" variant="body2">
          {eachClient.name}
        </MDTypography>
      ),
      website: (
        <MDTypography display="block" variant="body2">
          {eachClient.website}
        </MDTypography>
      ),
      category: (
        <MDTypography display="block" variant="body2">
          {getOptionLabel(categoryOptions, eachClient.category)}
        </MDTypography>
      ),
      action: (
        <MDBox display="flex">
          {pagePermission.status ? (
            <MDSwitch
              checked={!!eachClient.active}
              color="info"
              title="Active Status"
              onChange={() => updateClient(eachClient.id, !eachClient.active)}
            />
          ) : (
            ""
          )}
          {pagePermission.edit ? (
            <MDTypography
              mr={1}
              mt={1}
              component={Link}
              to={`/manage-clients/edit?id=${eachClient.id}`}
              title="Edit"
              display="block"
              variant="body2"
              color="info"
            >
              <Icon fontSize="small">edit</Icon>
            </MDTypography>
          ) : (
            ""
          )}
          {pagePermission.new ? (
            <MDTypography
              mr={1}
              mt={1}
              component={Link}
              to={`/manage-clients/add?id=${eachClient.id}`}
              title="Copy"
              display="block"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              <Icon fontSize="small">content_copy_icon</Icon>
            </MDTypography>
          ) : (
            ""
          )}
          {pagePermission.remove ? (
            <MDTypography
              mt={1}
              component={Link}
              onClick={() => handleClickOpen(eachClient.id)}
              title="Remove"
              display="block"
              variant="body2"
              color="error"
            >
              <Icon fontSize="small">delete</Icon>
            </MDTypography>
          ) : (
            ""
          )}
          {renderAlertSB}
        </MDBox>
      ),
    };
    allRows[index] = eachData;
  });

  return {
    columns: [
      { Header: "Id", accessor: "id", width: "10%", align: "left" },
      { Header: "Name", accessor: "name", width: "25%", align: "left" },
      { Header: "Website", accessor: "website", width: "25%", align: "left" },
      { Header: "Category", accessor: "category", width: "20%", align: "left" },
      ...(pagePermission.status || pagePermission.edit || pagePermission.remove
        ? [{ Header: "actions", accessor: "action", width: "20%", align: "center" }]
        : []),
    ],
    rows: allRows,
    open,
    handleClickOpen,
    handleClose,
    deleteClient,
    selectedId,
    totalData,
    page: page_no,
    pageSize: page_size,
    getData,
    sortColumn: sort_column,
    sortColumnValue: sort_column_value,
    searchValue: search_value,
    pagePermission,
    isData: isData,
  };
}
